// eslint-disable-next-line no-unused-vars
import { DEFAULT_DATE, FIRST_DAY_MONTH, FIRST_DAY_YEAR } from '@/components/utils/daterange/constants'

const filters = {
  orders: {
    page: 1,
    data: {
      date: [ FIRST_DAY_YEAR, DEFAULT_DATE ],
      type: 0,
      payment: 0,
      customers: [],
      addresses: [],
      order_op: 0,
      categories: [],
      order_list: [],
      status: []
    }
  },
  catalog: {
    page: 2,
    data: {
      date: [ null, null ],
      categories: [],
      price: [ null, null ],
      status: 0
    }
  },
  customers: {
    page: 6,
    data: {
      date: [ null, null ],
      addresses: [],
      phones: [],
      identities: [],
      payment: []
    }
  },
  financial: {
    page: 5,
    cashflow: {
      // date: [ FIRST_DAY_MONTH, DEFAULT_DATE ],
      date: [ '', '' ],
      type: 0,
      payment: [],
      categories: []
    },
    bills: {
      date: [ FIRST_DAY_MONTH, DEFAULT_DATE ]
      //date: [ '', '' ]
    },
    salary: {
      date: [ FIRST_DAY_MONTH, DEFAULT_DATE ]
      //date: [ '', '' ]
    },
    reports: {
      date: [ FIRST_DAY_MONTH, DEFAULT_DATE ]
      //date: [ '', '' ]
    }
  }
}
export default filters
